/* eslint-disable no-console */
// Use the modular API for accessing multiple databases
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  serverTimestamp,
  connectFirestoreEmulator
} from "firebase/firestore";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  connectAuthEmulator
} from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET
};

const webApi =
  "https://us-central1-incentable-app-37d9c.cloudfunctions.net/webApi/api/v1/";

// Initialize the app
const app = initializeApp(firebaseConfig);

// Get services
const dbGlobal = getFirestore(app, "(default)"); // Initialize the global database
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);
const timestamp = serverTimestamp();

// Create a reference to store the current database instance
let currentDb = null;

// Function to get a database by ID
function getFirestoreDatabase(databaseId = "(default)") {
  const supportedRegions = {
    "(default)": "(default)",
    sydney: "sydney",
    montreal: "montreal",
    singapore: "singapore",
    frankfurt: "frankfurt",
    london: "london"
  };

  // Use the provided databaseId if supported, or default to "(default)"
  const region = supportedRegions[databaseId] || "(default)";
  currentDb = getFirestore(app, region);

  return currentDb;
}

// Initialize the database
currentDb = getFirestoreDatabase("(default)"); // Initialize with default value

// Connect to emulators in development if needed
if (
  process.env.NODE_ENV === "development" &&
  process.env.VUE_APP_USE_EMULATORS === "true"
) {
  try {
    connectAuthEmulator(auth, "http://localhost:9099");
    connectFirestoreEmulator(dbGlobal, "localhost", 8080);
    connectFirestoreEmulator(currentDb, "localhost", 8080);
    connectFunctionsEmulator(functions, "localhost", 5001);
    connectStorageEmulator(storage, "localhost", 9199);
    console.log("Connected to Firebase emulators");
  } catch (error) {
    console.log("Emulators already connected or not available");
  }
}

// Enable local persistence for better user experience across page refreshes
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Firebase auth local persistence enabled
  })
  .catch(error => {
    console.error("Firebase auth persistence error:", error);
    // Don't throw here, just log the error
  });

// Add auth state ready promise
let authStateReady = false;
const authReadyPromise = new Promise(resolve => {
  const unsubscribe = auth.onAuthStateChanged(() => {
    if (!authStateReady) {
      authStateReady = true;
      unsubscribe();
      resolve();
    }
  });
});

// Export a getter function for db to always return the current instance
const db = () => currentDb;

export {
  db, // Export the function directly
  dbGlobal, // Export the global database
  webApi,
  timestamp,
  storage,
  auth,
  functions,
  authReadyPromise,
  getFirestoreDatabase
};
